package com.bikompanion.domain.usecase

import dev.zacsweers.metro.Inject
import com.bikompanion.domain.BikeType
import com.bikompanion.domain.StationWatchRepository
import com.bikompanion.domain.analytics.AnalyticsTracker
import com.bikompanion.domain.analytics.DomainAnalyticsEvents

@Inject
class CancelStationWatchUseCase(
    private val repository: StationWatchRepository,
    private val analytics: AnalyticsTracker,
) {
    /** Does nothing for a watch that already ended, so a late tap isn't reported as a cancellation. */
    operator fun invoke(
        networkId: String,
        stationId: String,
        bikeType: BikeType,
    ) {
        val watch = repository.watches().firstOrNull {
            it.networkId == networkId && it.stationId == stationId && it.bikeType == bikeType
        } ?: return
        repository.remove(networkId, stationId, bikeType)
        analytics.track(DomainAnalyticsEvents.stationWatchCancelled(watch))
    }
}
